import {useEffect, useState} from "react"
import BookGoalResponse from "./BookGoalResponse"
import {BooksitoutServer} from "../../../config/BooksitoutServer"

const useBookGoalsAll = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [goals, setGoals] = useState<BookGoalResponse[]>([])

    useEffect(() => {
        BooksitoutServer
            .get(`/v1/book/goals`)
            .then((res) => {
                setGoals(res.data)
            })
            .finally(() => setIsLoading(false))
    }, [])

    return [goals, isLoading] as const
}

export default useBookGoalsAll